import { createFileRoute, Link, redirect } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { MapPin, Plus } from 'lucide-react';
import { Button } from '@/common/components/ui/button';
import { supplyPointQueries } from '@/features/supply-points/queries';

export const Route = createFileRoute('/_authenticated/no-supply-points')({
  loader: async ({ context: { queryClient } }) => {
    const supplyPoints = await queryClient.ensureQueryData(supplyPointQueries.list());
    if (supplyPoints.length > 0) {
      throw redirect({ to: '/' });
    }
    return { breadcrumb: t`No supply points` };
  },
  component: NoSupplyPointsPage,
});

function NoSupplyPointsPage() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <div className="mb-6 flex size-20 items-center justify-center rounded-2xl bg-muted">
        <MapPin size={36} className="text-muted-foreground" />
      </div>
      <h1 className="mb-2 text-2xl font-bold">
        <Trans>No supply points yet</Trans>
      </h1>
      <p className="mb-8 max-w-sm text-muted-foreground">
        <Trans>
          Create your first supply point to get started. Supply points represent energy consumption
          locations you want to monitor and manage.
        </Trans>
      </p>
      <Button asChild>
        <Link to="/supply-points/new">
          <Plus className="mr-2 h-4 w-4" />
          <Trans>Create supply point</Trans>
        </Link>
      </Button>
    </div>
  );
}
